/**
 * Создает контроллер, который можно отменять другим контроллером для тех случаев, когда нам нужно иметь возможность отменять действие, опир
 */
export function deriveAbortController(mainController: AbortController): AbortController;

/**
 * Создает контроллер, который можно отменять другим контроллером для тех случаев, когда нам нужно иметь возможность отменять действие, опир
 */

export function deriveAbortController(mainSignal: AbortSignal): AbortController;
/**
 * Создает контроллер, который можно отменять другим контроллером для тех случаев, когда нам нужно иметь возможность отменять действие, опир
 */
export function deriveAbortController(main: AbortSignal | AbortController): AbortController {
  const cntrl = new AbortController();

  const mainSignal = main instanceof AbortSignal ? main : main.signal;

  function onabort() {
    cntrl.abort();
    mainSignal.removeEventListener('abort', onabort);
  }

  mainSignal.addEventListener('abort', onabort);

  return cntrl;
}

/**
 * Создает сигнал, который отменяется, если хотя бы один из основных сигналов будет отменен
 */
export function mergeSignals(...signals: AbortSignal[]): AbortSignal {
  const controller = new AbortController();

  function onabort() {
    controller.abort();

    for (const signal of signals) {
      signal.removeEventListener('abort', onabort);
    }
  }

  for (const signal of signals) {
    signal.addEventListener('abort', onabort);
  }

  return controller.signal;
}
